import { Pipe, PipeTransform } from '@angular/core';
import { AuthorisationService } from '../services/auth/authorisation.service';
import { Functionalities } from '../services/auth/functionalities';
import { Status } from '../status.interface';

@Pipe({
    name: 'statusDisabled',
    standalone: false,
})
export class StatusDisabledPipe implements PipeTransform {
    transform<T>(status: Status, waymark: string, status_id: number): boolean {
        // When this status is currently selected, status is never disabled

        if (AuthorisationService.hasFunctionality(Functionalities.GeoRestricted)) {
            return ![104, 130, 131].includes(status_id) || ![130, 131].includes(status.id);
        }

        if (status.id === status_id) {
            return false;
        }

        // Wacht op markering, gemarkeerd
        if (status.id === 130 || status.id === 131) {
            if (!waymark || waymark === 'Niet van toepassing') {
                return true;
            }
        }
        // Afgegoten
        if (status.id === 121) {
            if (waymark && waymark !== 'Niet van toepassing') {
                return true;
            }
        }
    }
}
